import type { ReactNode } from 'react';
import { useInView } from '@/hooks/useInView';
import { cn } from '@/lib/utils';

interface RevealProps {
  children: ReactNode;
  className?: string;
}

/** Restrained fade + 10px rise as a section enters the viewport, once. Not a
 * decorative flourish -- a subtle cue that the page is composed of distinct
 * moments rather than one flat scroll. prefers-reduced-motion skips it
 * entirely (see useInView.ts). */
const Reveal = ({ children, className }: RevealProps) => {
  const { ref, inView } = useInView<HTMLDivElement>();
  return (
    <div
      ref={ref}
      className={cn(
        'transition-[opacity,transform] duration-500 ease-out motion-reduce:transition-none',
        inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3',
        className
      )}
    >
      {children}
    </div>
  );
};

export default Reveal;
